export default (els) => {
	Array.prototype.forEach.call(els, (el) => {
		const closeButton = el.querySelector('button');

		const announcementClosed = document.cookie
			.split('; ')
			.find((row) => row.startsWith('AnnouncementClosed='))
			?.split('=')[1];

		var now = new Date();
		var time = now.getTime();
		time += 3600 * 1000;
		now.setTime(time);

		if (!announcementClosed) {
			document.cookie = 'AnnouncementClosed=false; max-age=3600;';
		}

		if (announcementClosed == 'true') {
			el.classList.add('!hidden');
		}

		closeButton.addEventListener('click', function () {
			el.classList.add('!hidden');

			if (announcementClosed == 'false') {
				document.cookie = 'AnnouncementClosed=true;';
			}
		});
	});
};
